import { slug } from '~utils/functions/slug'

const getCreateMapLink = ({ workspaceId, workspaceName }) => {
  return `/workspace/${workspaceId}/${slug(workspaceName)}/create-map`
}

export { getCreateMapLink }
